import React from 'react';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import NoPaperPageContent from 'components/Generic/NoPaperPageContent';
import Header from 'components/Header';
import Versioning from './InfoPage';

interface StateInterface {
  referer: string;
}

const Title = () => {
  const { t } = useTranslation();
  return (
    <>
      <Typography color="primary" variant="inherit">
        {t('infoPage.welcome') + ' '}
      </Typography>
      <Typography color="textPrimary" variant="inherit">
        {t('infoPage.toEtem')}
      </Typography>
    </>
  );
};

const VersioningPage: React.FC = () => {
  const history = useHistory<StateInterface>();

  const previousLocation = !!history.location.state ? history.location.state.referer : '/';

  return (
    <>
      <Header />
      <Box marginLeft="3%" paddingTop="125px">
        <NoPaperPageContent title={<Title />} backRoute={previousLocation}>
          <Versioning />
        </NoPaperPageContent>
      </Box>
    </>
  );
};
export default VersioningPage;
